const getPrevLocation = ({
  replace,
  location
}) => {
  return replace ? location.state?.prevLocation : location;
};

export { getPrevLocation as default };
//# sourceMappingURL=getPrevLocation.mjs.map
